// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// Example: AND

export const MultiSelectOperatorTypeSchema = t.keyof({
  AND: null,
  OR: null,
});

export type MultiSelectOperatorType = t.TypeOf<typeof MultiSelectOperatorTypeSchema>;
